import _                   from 'lodash';
import { Reducer }         from 'alto-utils/lib/store';
import { BadRequestError } from 'lib/errors';

export class CanteenReducer extends Reducer {
  static initClass() {
    this.prototype.initialState = {
      menu:              null,
      terminal:          null,
      selectedDate:      null,
      selectedCanteenID: null,
      menuSavingError:   null,
      orderSummary:      false,
      menuIsBeingSaved:  false
    };
  }

  loadMenuFulfilled(state, action) {
    return { ...state, menu: action.payload };
  }

  loadTerminalFulfilled(state, action) {
    return { ...state, terminal: action.payload };
  }

  updateMenu(state, action) {
    return { ...state, menu: action.menu };
  }

  selectDate(state, action) {
    return { ...state, selectedDate: action.date };
  }

  selectCanteen(state, action) {
    return { ...state, selectedCanteenID: action.id };
  }

  selectMeal(state, action) {
    return { ...state, menu: state.menu.select(action.meal) };
  }

  deselectMeal(state, action) {
    return { ...state, menu: state.menu.deselect(action.canteenID, action.date, action.course) };
  }

  startSavingMenu(state) {
    return { ...state, menuIsBeingSaved: true };
  }

  finishSavingMenu(state) {
    return { ...state, menuIsBeingSaved: false };
  }

  showOrderSummary(state) {
    return { ...state, orderSummary: true };
  }

  hideOrderSummary(state) {
    return { ...state, orderSummary: false };
  }

  setMenuSavingError(state, action) {
    if (action.error instanceof BadRequestError) {
      let { data } = action.error;

      if (_.isArray(data)) {
        data = _.find(data, _.negate(_.isEmpty));
      }

      if (data.orders && _.every(data.orders, { code: 'order_is_already_being_created' })) {
        return state; // all errors were concurrency ones, ignore them
      }
    }

    return { ...state, menuSavingError: action.error };
  }

  clearMenuSavingError(state) {
    return { ...state, menuSavingError: null };
  }

  forgetMenu(state) {
    return { ...state, menu: null };
  }

  forgetCanteenData() {
    return this.initialState;
  }
};

CanteenReducer.initClass();

export const canteenReducer = (new CanteenReducer).dispatch;
